import { render, staticRenderFns } from "./PorAcs.vue?vue&type=template&id=27dac720"
import script from "./PorAcs.vue?vue&type=script&lang=js"
export * from "./PorAcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports